import script from "./HelloWorld.vue?vue&type=script&setup=true&lang=js"
export * from "./HelloWorld.vue?vue&type=script&setup=true&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=154a1d1e&lang=css"

const __exports__ = script;

export default __exports__